import Table from "../components/rate-adjustment-case-list/Table";
import SearchBar from "../components/rate-adjustment-case-list/SearchBar";
import { SpaceBetween } from "@cloudscape-design/components-themed";

import { PERMISSIONS } from "../configs/constants";
import { useAuthenticationHook } from "../app/useAuthenticationHook";

/* 
料率調整案件一覧画面
 */
const RateAdjustmentCaseList = () => {
  //権限制御
  useAuthenticationHook(PERMISSIONS.RATE_SETTING);

  return (
    <SpaceBetween size="l">
      <SearchBar />
      <Table />
    </SpaceBetween>
  );
};

export default RateAdjustmentCaseList;
